import React, { ReactNode } from "react";
import "./ErrorMessage.scss";

type ErrorMessageProps = {
  children: ReactNode;
  className?: string;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  children,
  className
}: ErrorMessageProps) => {
  return <p className={`error-message override  ${className}`}>{children}</p>;
};

export default ErrorMessage;
